import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, ArrowRight, Plus, Trash2, Loader2,  Edit } from 'lucide-react';
import  toast, { Toaster } from 'react-hot-toast';
import { formConfig } from './productFormConfig';
import axios from 'axios';
import Select from 'react-select';
import AssetSelectionModal from '../onBoardingAsset/AssetSelectionModal';
import TagInput from './TagInput';
import heartLoading from "../../../../assests/heartLoading.gif"
import preloader from "../../../../assests/preloader1.gif"
import Tooltip from '@mui/material/Tooltip';

const OnboardProduct = ({ onNext, userRole }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingCodes, setIsLoadingCodes] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [proudctId, setProductId] = useState("")
  const [formData, setFormData] = useState({
    // Basic Information
    productName: '',
    productCode: '',
    description: '',
    dataLayer: '',
    
    // Market Information
    marketRegion: [],
    lineOfBusiness: '',

    //Hierarchy Information
    hierarchy_1: '',
    hierarchy_2: '',
    hierarchy_3: '',
    hierarchy_4: '',
    hierarchy_5: '',
    
    // Cost Information
    developmentCosts: [],
    supportCosts: [],
    operationCosts: [],
    costThreshold: '',
    sizeThreshold: '',
    sizeThresholdUnit: '',
    
    // Additional Information
    expectedUsers: '',
    valueMapping: '',
    azureServicesCost: '',
    domain: '',
    subDomain: '',
    subSubDomain: '',
    slaResponseTime: '',
    slaResponseTimeUnit: '',
    slaUptime: '',
    assetSource: [],
    productOwner: '',
    productTag: [],
    productDocumentationUrl: '',
    marketCountry: []
  });
  const [showAssetModal, setShowAssetModal] = useState(false);
  const [productCodeOptions, setProductCodeOptions] = useState([]);
  const [selectedProductCode, setSelectedProductCode] = useState('');
  const [domainData, setDomainData] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [selectedSubDomain, setSelectedSubDomain] = useState(null);
  const [selectedSubSubDomain, setSelectedSubSubDomain] = useState(null);
  const [subdomainOptions, setSubdomainOptions] = useState([]);
  const [subSubdomainOptions, setSubSubdomainOptions] = useState([]);
  const [isDomainEditMode, setIsDomainEditMode] = useState(false);
  const [isMarketEditMode, setIsMarketEditMode] = useState(id ? false : true);
  const [regionsCountriesData, setRegionsCountriesData] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [domainId, setDomainId] = useState("");
  const [subDomainId, setSubDomainId] = useState("");
  const [subSubDomainId, setSubSubDomainId] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileConfigurations, setFileConfigurations] = useState({});
  const [configForm, setConfigForm] = useState({
    assetName: '',
    assetDescription: '',
    dataAssetOwner: '',
    region: '',
    market: '',
    technicalDataSteward: '',
    refreshFrequency: '',
    completeness: '',
    accuracy: '',
    consistency: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [productNameOptions, setProductNameOptions] = useState([]);
  const [selectedProductName, setSelectedProductName] = useState('');
  const [isProductOwnerEmailValid, setIsProductOwnerEmailValid] = useState(true);

  // console.log("selectedProductNmae", selectedProductName)

  console.log("formData",  formData)

  // console.log("domain data", domainData)
  console.log("Parent domain id", domainId)
  console.log("domainId", subDomainId);
  console.log("subDomainId", subSubDomainId)

  
  console.log("formData", formData)
  
  // Allowed email domains
  const ALLOWED_EMAIL_DOMAINS = ['aaysinsight.com'];
  
  // Validate product owner email
  const validateProductOwnerEmail = (email) => {
    if (!email || email.trim() === '') {
      return true; // Empty email is considered valid for save functionality
    }
    const emailPattern = /^[^\s@]+@([^\s@]+)$/;
    const match = email.match(emailPattern);
    if (!match) return false;
    
    const domain = match[1];
    return ALLOWED_EMAIL_DOMAINS.includes(domain);
  };

  // Validate dates in cost periods
  const validateDates = () => {
    const costTypes = ['developmentCosts', 'supportCosts', 'operationCosts'];
    
    for (const costType of costTypes) {
      if (formData[costType] && formData[costType].length > 0) {
        for (const period of formData[costType]) {
          // Skip validation if cost is 0 or empty (dates are not required)
          if (!period.cost || period.cost <= 0) {
            continue;
          }
          
          // Check if dates are provided when cost is provided
          if (!period.startDate || !period.endDate) {
            toast.error(`Please provide both start and end dates for ${costType.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
            return false;
          }
          
          // Validate date format and values
          const startDate = new Date(period.startDate);
          const endDate = new Date(period.endDate);
          
          // Check if dates are valid
          if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            toast.error(`Please provide valid dates for ${costType.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
            return false;
          }
          
          // Check if start date is before end date
          if (startDate >= endDate) {
            toast.error(`End date must be after start date for ${costType.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
            return false;
          }
        }
      }
    }
    
    return true;
  };

  // Update email validation state when productOwner changes
  useEffect(() => {
    const isValid = validateProductOwnerEmail(formData.productOwner);
    setIsProductOwnerEmailValid(isValid);
  }, [formData.productOwner]);

  useEffect(() => {
    const fetchEditData = async () => {
      if (!id) return;
      try {
        setIsLoadingDetails(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/edit-form/${id}`);
        if (response.status === 200 && response.data) {
          const data = response.data;
          // Map API response to formData, skipping 'N/A' values
          const newFormData = { ...formData };
          const fieldMap = {
            productName: 'productName',
            productCode: 'productCode',
            description: 'description',
            productOwner: 'productOwner',
            hierarchy_1: 'hierarchy_1',
            hierarchy_2: 'hierarchy_2',
            hierarchy_3: 'hierarchy_3',
            hierarchy_4: 'hierarchy_4',
            hierarchy_5: 'hierarchy_5',
            dataLayer: 'dataLayer',
            lineOfBusiness: 'lineOfBusiness',
            costThreshold: 'costThreshold',
            valueMapping: 'valueMapping',
            azureServicesCost: 'azureServicesCost',
            slaUptime: 'slaUptime',
            productTag: 'productTag',
            productDocumentationUrl: 'productDocumentationUrl',
            minExpectedUsers: 'minExpectedUsers',
            maxExpectedUsers: 'maxExpectedUsers',
            status: 'status',
          };
          Object.entries(fieldMap).forEach(([apiKey, formKey]) => {
            if (data[apiKey] !== undefined && data[apiKey] !== 'N/A') {
              newFormData[formKey] = data[apiKey];
            }
          });
          
          // Handle market region and country as arrays
          if (data.marketRegion && data.marketRegion !== 'N/A') {
            const marketRegions = Array.isArray(data.marketRegion) ? data.marketRegion : [data.marketRegion];
            newFormData.marketRegion = marketRegions;
            setSelectedRegions(marketRegions.map(region => ({ value: region, label: region })));
          }
          
          if (data.marketCountry && data.marketCountry !== 'N/A') {
            const marketCountries = Array.isArray(data.marketCountry) ? data.marketCountry : [data.marketCountry];
            newFormData.marketCountry = marketCountries;
          }
          setSelectedProductName(newFormData?.productName)
          // Nested fields
          if (data.sizeThreshold && data.sizeThreshold.value !== 'N/A') {
            newFormData.sizeThreshold = data.sizeThreshold.value;
            newFormData.sizeThresholdUnit = data.sizeThreshold.unit !== 'N/A' ? data.sizeThreshold.unit : '';
          }
          if (data.slaResponseTime && data.slaResponseTime.value !== 'N/A') {
            newFormData.slaResponseTime = data.slaResponseTime.value;
            newFormData.slaResponseTimeUnit = data.slaResponseTime.unit !== 'N/A' ? data.slaResponseTime.unit : '';
          }
          // Array fields
          ['developmentCosts', 'supportCosts', 'operationCosts'].forEach(arrKey => {
            if (Array.isArray(data[arrKey]) && data[arrKey].length > 0 && data[arrKey][0].cost !== 'N/A') {
              newFormData[arrKey] = data[arrKey];
            }
          });
          // Domain fields (IDs)
          if (data.parentDomainId && data.parentDomainId !== 'N/A') setDomainId(data.parentDomainId);
          if (data.domainId && data.domainId !== 'N/A') setSubDomainId(data.domainId);
          if (data.subDomainId && data.subDomainId !== 'N/A') setSubSubDomainId(data.subDomainId);
           newFormData.domain = data?.parentDomainName || "";
           newFormData.subDomain = data?.domainName || "";
           newFormData.subSubDomain = data?.subDomainName || ""
          //  newFormData.assetSource = data?.assetSource
           console.log("asset, sources", data.assetSource)

           const assetSourceLabels = {
            adls: 'ADLS',
            uc: 'UC',
            manual: 'Manual'
          };

           const normalizeToArray = (input) => {
            if (!input) return [];
            return Array.isArray(input) ? input : [input];
          };
          
          newFormData.assetSource = normalizeToArray(data?.assetSource).map((key) => ({
            value: key,
            label: assetSourceLabels[key] || key.toUpperCase()
          }));
          // Set form data
          setFormData(newFormData);
          // Optionally, set selectedProductCode if editing
          if (data.productCode && data.productCode !== 'N/A') setSelectedProductCode(data.productCode);
        }
      } catch (error) {
        toast.error('Failed to fetch product for editing');
      } finally {
        setIsLoadingDetails(false);
      }
    };
    fetchEditData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);


  // Fetch product codes and domain data on component mount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // Fetch product names
        setIsLoadingCodes(true);
        const productNamesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/product-names`);
        if (productNamesResponse.status === 200) {
          // productNames
          const names = productNamesResponse.data.productNames.map(name => ({
            value: name,
            label: name
          }));
          setProductNameOptions(names);
        }
        // Fetch product codes (for edit mode only, if needed)
        // const productCodesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/product-codes`);
        // if (productCodesResponse.status === 200) {
        //   const codes = productCodesResponse.data.productCodes.map(code => ({
        //     value: code,
        //     label: code
        //   }));
        //   setProductCodeOptions(codes);
        // }
        // Fetch domain data
        const domainResponse = await axios.get(`${process.env.REACT_APP_API_URL}/parentdomain_domain_subdomain_list/`);
        if (domainResponse.status === 200) {
          setDomainData(domainResponse.data.parent_domains);
        }
        // Fetch regions and countries
        const regionsCountriesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/regions-countries-list/`);
        if (regionsCountriesResponse.status === 200) {
          setRegionsCountriesData(regionsCountriesResponse.data);
        }
      } catch (error) {
        console.error('Error fetching initial data:', error);
        toast.error('Failed to fetch initial data');
      } finally {
        setIsLoadingCodes(false);
      }
    };
    fetchInitialData();
  }, []);
  useEffect(() => {
    localStorage.setItem("assetSource", JSON.stringify(formData.assetSource))
  },[formData.assetSource])


  // Update subdomain options when domain changes
  useEffect(() => {
    if (selectedDomain) {
      const parentDomain = domainData.find(d => d.parent_domain_id === selectedDomain.value);
      if (parentDomain) {
        const subdomains = parentDomain.domains.map(domain => ({
          value: domain.domain_id,
          label: domain.domain
        }));
        setSubdomainOptions(subdomains);
        setSubSubdomainOptions([]); // Reset sub-subdomain options
      }
    } else {
      setSubdomainOptions([]);
      setSubSubdomainOptions([]);
    }
  }, [selectedDomain, domainData]);

  // Update sub-subdomain options when subdomain changes
  useEffect(() => {
    if (selectedSubDomain && selectedDomain) {
      const parentDomain = domainData.find(d => d.parent_domain_id === selectedDomain.value);
      if (parentDomain) {
        const domain = parentDomain.domains.find(d => d.domain_id === selectedSubDomain.value);
        if (domain) {
          const subSubdomains = domain.sub_domains.map(sub => ({
            value: sub.sub_domain_id,
            label: sub.sub_domain
          }));
          setSubSubdomainOptions(subSubdomains);
        }
      }
    } else {
      setSubSubdomainOptions([]);
    }
  }, [selectedSubDomain, selectedDomain, domainData]);

  // Update country options when regions change
  useEffect(() => {
    if (selectedRegions && selectedRegions.length > 0) {
      // Get all countries from all selected regions
      const allCountries = [];
      selectedRegions.forEach(selectedRegion => {
        const region = regionsCountriesData.find(r => r.region === selectedRegion.value);
        if (region) {
          region.countries.forEach(country => {
            if (!allCountries.find(c => c.value === country)) {
              allCountries.push({
                value: country,
                label: country
              });
            }
          });
        }
      });
      setCountryOptions(allCountries);
    } else {
      setCountryOptions([]);
    }
  }, [selectedRegions, regionsCountriesData]);

  // Edit mode: fetch and populate form if id is present
  

  const handleDomainChange = (selectedOption) => {
    setSelectedDomain(selectedOption);
    setSelectedSubDomain(null);
    setSelectedSubSubDomain(null);
    setFormData(prev => ({
      ...prev,
      domain: selectedOption ? selectedOption.value : '',
      subDomain: '',
      subSubDomain: ''
    }));
  };

  const handleSubdomainChange = (selectedOption) => {
    setSelectedSubDomain(selectedOption);
    setSelectedSubSubDomain(null);
    setFormData(prev => ({
      ...prev,
      subDomain: selectedOption ? selectedOption.value : '',
      subSubDomain: ''
    }));
  };

  const handleSubSubdomainChange = (selectedOption) => {
    setSelectedSubSubDomain(selectedOption);
    setFormData(prev => ({
      ...prev,
      subSubDomain: selectedOption ? selectedOption.value : ''
    }));
  };

  const handleRegionChange = (selectedOptions) => {
    setSelectedRegions(selectedOptions || []);
    
    // Get all countries from selected regions and auto-select them
    const allCountries = [];
    const allCountryValues = [];
    
    if (selectedOptions && selectedOptions.length > 0) {
      selectedOptions.forEach(selectedRegion => {
        const region = regionsCountriesData.find(r => r.region === selectedRegion.value);
        if (region) {
          region.countries.forEach(country => {
            if (!allCountries.find(c => c.value === country)) {
              allCountries.push({
                value: country,
                label: country
              });
              allCountryValues.push(country);
            }
          });
        }
      });
    }
    
    setFormData(prev => ({
      ...prev,
      marketRegion: selectedOptions ? selectedOptions.map(option => option.value) : [],
      marketCountry: allCountryValues // Auto-select all countries from selected regions
    }));
  };

  const handleCountryChange = (selectedOptions) => {
    setFormData(prev => ({
      ...prev,
      marketCountry: selectedOptions ? selectedOptions.map(option => option.value) : []
    }));
  };

  const handleProductNameSelect = async (selectedOption) => {
    if (!selectedOption) return;
    setSelectedProductName(selectedOption.value);
    setFormData(prev => ({ ...prev, productName: selectedOption.value }));
    try {
      setIsLoadingDetails(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product-details/${selectedOption.value}`);
      if (response.status === 200) {
        const details = response.data;
        setFormData(prev => ({
          ...prev,
          productCode: details.product_code || '',
          description: details.product_description || '',
          dataLayer: details.dataLayer || '',
          domain: details.parent_domain_name || '',
          subDomain: details.domain || '',
          subSubDomain: details.sub_domain || '',
          productOwner: details.product_owner || ''
        }));
        setDomainId(details.parent_domain_id);
        setSubDomainId(details.domain_id);
        setSubSubDomainId(details.sub_domain_id);
      }
    } catch (error) {
      console.error('Error fetching product details:', error);
      toast.error('Failed to fetch product details');
    } finally {
      setIsLoadingDetails(false);
    }
  };

  const handleProductCodeSelect = async (selectedOption) => {
    if (!selectedOption) return;
    
    setSelectedProductCode(selectedOption.value);
    setFormData(prev => ({ ...prev, productCode: selectedOption.value }));

    try {
      setIsLoadingDetails(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product-details/${selectedOption.value}`);
      // console.log('Product details response:', response.data);

      if (response.status === 200) {
        const details = response.data;
        
        // Find and set the parent domain
        // const parentDomain = domainData.find(d => d.parent_domain_id === details.parent_domain_id);
        // if (parentDomain) {
        //   const domainOption = { value: parentDomain.parent_domain_id, label: parentDomain.parent_domain };
        //   setSelectedDomain(domainOption);
          
        //   // Find and set the domain
        //   const domain = parentDomain.domains.find(d => d.domain_id === details.domain_id);
        //   if (domain) {
        //     const subdomainOption = { value: domain.domain_id, label: domain.domain };
        //     setSelectedSubDomain(subdomainOption);
            
        //     // Find and set the sub domain
        //     const subdomain = domain.sub_domains.find(s => s.sub_domain_id === details.sub_domain_id);
        //     if (subdomain) {
        //       const subSubdomainOption = { value: subdomain.sub_domain_id, label: subdomain.sub_domain };
        //       setSelectedSubSubDomain(subSubdomainOption);
        //     }
        //   }
        // }

        // Update form data with all values
        setFormData(prev => ({
          ...prev,
          productName: details.product_name || '',
          description: details.product_description || '',
          dataLayer: details.dataLayer || '',
          domain: details.parent_domain_name || '',  // This is the parent domain name
          subDomain: details.domain || '',          // This is the domain
          subSubDomain: details.sub_domain || '',   // This is the sub domain
          productOwner: details.product_owner || ''
        }));
        
        // Set IDs for reference
        setDomainId(details.parent_domain_id);
        setSubDomainId(details.domain_id);
        setSubSubDomainId(details.sub_domain_id);

        // Log the values to verify
        console.log('Setting domain values:', {
          parentDomainName: details.parent_domain_name,
          domain: details.domain,
          subDomain: details.sub_domain,
          formDataDomain: details.parent_domain_name
        });
      }
    } catch (error) {
      console.error('Error fetching product details:', error);
      toast.error('Failed to fetch product details');
    } finally {
      setIsLoadingDetails(false);
    }
  };

  console.log(formData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if user is Data Engineer or Vendor
    const dataEngineerVendorRoles = ['Data Engineer', 'Vendor'];
    if (dataEngineerVendorRoles.includes(userRole)) {
      toast.error('You are not authorized to submit this form.');
      return;
    }
    
    if (!validateForm()) {
      return;
    }

    // Validate dates before proceeding
    if (!validateDates()) {
      return;
    }

    try {
      setIsSubmitting(true);
      
      const selectedDomainObj = domainData.find(d => d.domain_id === formData.domain);
      const selectedSubdomainObj = selectedDomainObj?.sub_domains.find(s => s.sub_domain_id === formData.subDomain);

      const submitData = {
        ...formData,
        sizeThreshold: {
          value: formData.sizeThreshold !== undefined && formData.sizeThreshold !== null && formData.sizeThreshold !== '' ? formData.sizeThreshold : null,
          unit: formData.sizeThresholdUnit || ""
        },
        slaResponseTime: {
          value: formData.slaResponseTime !== undefined && formData.slaResponseTime !== null && formData.slaResponseTime !== '' ? formData.slaResponseTime : null,
          unit: formData.slaResponseTimeUnit || ""
        },
        azureServicesCost: formData.azureServicesCost !== undefined && formData.azureServicesCost !== null && formData.azureServicesCost !== '' ? formData.azureServicesCost : null,
        costThreshold: formData.costThreshold !== undefined && formData.costThreshold !== null && formData.costThreshold !== '' ? formData.costThreshold.toString() : '',
        // slaResponseTime: formData.slaResponseTime.toString(),
        parentDomainId: !isDomainEditMode ? domainId : selectedDomain?.value || '',
        parentDomain: !isDomainEditMode ? formData.domain : selectedDomain?.label || '',
        domainId: !isDomainEditMode ? subDomainId : selectedSubDomain?.value || '',
        domain: !isDomainEditMode ? formData.subDomain : selectedSubDomain?.label || '',
        subDomainId: !isDomainEditMode ? subSubDomainId : selectedSubSubDomain?.value || '',
        subDomain: !isDomainEditMode ? formData.subSubDomain : selectedSubSubDomain?.label || '',
        assetSource: formData.assetSource?.map(source => source.value) || [],
        slaUptime: formData.slaUptime !== undefined && formData.slaUptime !== null && formData.slaUptime !== '' ? formData.slaUptime.toString() : '',
        minExpectedUsers: formData.minExpectedUsers !== undefined && formData.minExpectedUsers !== null && formData.minExpectedUsers !== '' ? formData.minExpectedUsers.toString() : '',
        maxExpectedUsers: formData.maxExpectedUsers !== undefined && formData.maxExpectedUsers !== null && formData.maxExpectedUsers !== '' ? formData.maxExpectedUsers.toString() : '',
        status: 'submit',
        marketRegion: formData.marketRegion,
        marketCountry: formData.marketCountry,
        hierarchy_1: formData.hierarchy_1,
        hierarchy_2: formData.hierarchy_2,
        hierarchy_3: formData.hierarchy_3,
        hierarchy_4: formData.hierarchy_4,
        hierarchy_5: formData.hierarchy_5,
      };

      ['domain', 'subDomain', 'subSubDomain', 'parentDomain','sizeThresholdUnit','expectedUsers'].forEach(key => {
        if (submitData.hasOwnProperty(key)) {
          delete submitData[key];
        }
      });

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/submit-product`, submitData);

      if (response.status === 200 || response.status === 201) {
        toast.success('Product onboarded successfully! You can now proceed to the next step.');
        setProductId(response?.data?.product_id)
        // setShowAssetModal(true)
        localStorage.setItem("selectionId",response?.data?.product_id)
        onNext();
      } else {
        throw new Error('Failed to onboard product');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error(error.response?.data?.message || 'Something went wrong while onboarding the product. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSaveDraft = async () => {
    // Check if user is Data Engineer or Vendor
    const dataEngineerVendorRoles = ['Data Engineer', 'Vendor'];
    if (dataEngineerVendorRoles.includes(userRole)) {
      toast.error('You are not authorized to save drafts.');
      return;
    }

    // Validate product name is selected
    if (!formData.productName || formData.productName.trim() === '') {
      toast.error('Please select Product Name first');
      return;
    }

    // if (!validateForm()) {
    //   return;
    // }

    // Validate email if provided
    if (formData.productOwner && formData.productOwner.trim() !== '') {
      if (!validateProductOwnerEmail(formData.productOwner)) {
        toast.error(`Please enter a valid email address for Product Owner from: ${ALLOWED_EMAIL_DOMAINS.join(', ')}`);
        return;
      }
    }

    // Validate dates before proceeding (even for draft saves)
    if (!validateDates()) {
      return;
    }

    try {
      setIsSaving(true);
      
      const selectedDomainObj = domainData.find(d => d.domain_id === formData.domain);
      const selectedSubdomainObj = selectedDomainObj?.sub_domains.find(s => s.sub_domain_id === formData.subDomain);

      const submitData = {
        ...formData,
        sizeThreshold: {
          value: formData.sizeThreshold !== undefined && formData.sizeThreshold !== null && formData.sizeThreshold !== '' ? formData.sizeThreshold : null,
          unit: formData.sizeThresholdUnit || ""
        },
        slaResponseTime: {
          value: formData.slaResponseTime !== undefined && formData.slaResponseTime !== null && formData.slaResponseTime !== '' ? formData.slaResponseTime : null,
          unit: formData.slaResponseTimeUnit || ""
        },
        azureServicesCost: formData.azureServicesCost !== undefined && formData.azureServicesCost !== null && formData.azureServicesCost !== '' ? formData.azureServicesCost : null,
        costThreshold: formData.costThreshold !== undefined && formData.costThreshold !== null && formData.costThreshold !== '' ? formData.costThreshold.toString() : '',
        // slaResponseTime: formData.slaResponseTime.toString(),
        parentDomainId: !isDomainEditMode ? domainId : selectedDomain?.value || '',
        parentDomain: !isDomainEditMode ? formData.domain : selectedDomain?.label || '',
        domainId: !isDomainEditMode ? subDomainId : selectedSubDomain?.value || '',
        domain: !isDomainEditMode ? formData.subDomain : selectedSubDomain?.label || '',
        subDomainId: !isDomainEditMode ? subSubDomainId : selectedSubSubDomain?.value || '',
        subDomain: !isDomainEditMode ? formData.subSubDomain : selectedSubSubDomain?.label || '',
        assetSource: formData.assetSource?.map(source => source.value) || [],
        slaUptime: formData.slaUptime !== undefined && formData.slaUptime !== null && formData.slaUptime !== '' ? formData.slaUptime.toString() : '',
        minExpectedUsers: formData.minExpectedUsers !== undefined && formData.minExpectedUsers !== null && formData.minExpectedUsers !== '' ? formData.minExpectedUsers.toString() : '',
        maxExpectedUsers: formData.maxExpectedUsers !== undefined && formData.maxExpectedUsers !== null && formData.maxExpectedUsers !== '' ? formData.maxExpectedUsers.toString() : '',
        status: 'save',
        marketRegion: formData.marketRegion,
        marketCountry: formData.marketCountry,
        hierarchy_1: formData.hierarchy_1,
        hierarchy_2: formData.hierarchy_2,
        hierarchy_3: formData.hierarchy_3,
        hierarchy_4: formData.hierarchy_4,
        hierarchy_5: formData.hierarchy_5,
      };

      ['domain', 'subDomain', 'subSubDomain', 'parentDomain','sizeThresholdUnit','expectedUsers'].forEach(key => {
        if (submitData.hasOwnProperty(key)) {
          delete submitData[key];
        }
      });

      let payload  = submitData;

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/submit-product`, submitData);

      if (response.status === 200 || response.status === 201) {
        toast.success('Draft saved successfully!');
      } else {
        throw new Error('Failed to save draft');
      }
    } catch (error) {
      console.error('Error saving draft:', error);
      toast.error(error.response?.data?.message || 'Something went wrong while saving the draft. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  const addCostPeriod = (type) => {
    const newPeriod = {
      id: Date.now().toString(),
      startDate: '',
      endDate: '',
      cost: ''
    };
    setFormData({
      ...formData,
      [type]: [...formData[type], newPeriod]
    });
  };

  const removeCostPeriod = (type, id) => {
    setFormData({
      ...formData,
      [type]: formData[type].filter(period => period.id !== id)
    });
  };

  const updateCostPeriod = (type, id, field, value) => {
    setFormData({
      ...formData,
      [type]: formData[type].map(period =>
        period.id === id ? { ...period, [field]: value } : period
      )
    });
  };

  const validateForm = () => {
    const requiredFields = Object.values(formConfig)
      .flatMap(section => 
        section.fields ? section.fields : 
        section.thresholds ? section.thresholds : []
      )
      .filter(field => field.required)
      .map(field => field.name);

    const missingFields = requiredFields.filter(field => {
      if (field === 'assetSource') {
        return !formData[field] || formData[field].length === 0;
      }
      if (field === 'productTag') {
        return !formData[field] || formData[field].length === 0;
      }
      if (field === 'developmentCosts' || field === 'supportCosts' || field === 'operationCosts') {
        return !formData[field] || formData[field].length === 0;
      }
      return !formData[field];
    });
    
    if (missingFields.length > 0) {
      const fieldLabels = missingFields.map(field => {
        const section = Object.values(formConfig).find(section => 
          section.fields?.find(f => f.name === field) || 
          section.thresholds?.find(t => t.name === field)
        );
        const fieldConfig = section?.fields?.find(f => f.name === field) || 
                          section?.thresholds?.find(t => t.name === field);
        return fieldConfig?.label || field;
      });
      toast.error(`Please fill in all required fields: ${fieldLabels.join(', ')}`);
      return false;
    }

    // Validate email format if email field exists (any valid email)
    if (formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        toast.error('Please enter a valid email address');
        return false;
      }
    }

    // Validate productOwner email format (only aaysinsight.com domain)
    if (formData.productOwner) {
      const emailPattern = /^[^\s@]+@([^\s@]+)$/;
      const match = formData.productOwner.match(emailPattern);
      if (!match || !ALLOWED_EMAIL_DOMAINS.includes(match[1])) {
        toast.error(`Please enter a valid email address for Product Owner from: ${ALLOWED_EMAIL_DOMAINS.join(', ')}`);
        return false;
      }
    }

    // Validate cost periods
    const costTypes = ['developmentCosts', 'supportCosts', 'operationCosts'];
    for (const costType of costTypes) {
      if (formData[costType].length > 0) {
        const invalidPeriods = formData[costType].filter(
          period => !period.startDate || !period.endDate || period.cost === '' || period.cost === null || period.cost === undefined || period.cost < 0
        );
        if (invalidPeriods.length > 0) {
          toast.error(`Please fill in all required fields for ${costType}`);
          return false;
        }
      }
    }

    // Validate SLA Uptime is between 1 and 100
    if (formData.slaUptime && (formData.slaUptime < 1 || formData.slaUptime > 100)) {
      toast.error('SLA Uptime must be between 1 and 100');
      return false;
    }

    // Validate URL field for Product Documentation
    if (formData.productDocumentationUrl) {
      const urlRegex = /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/;
      if (!urlRegex.test(formData.productDocumentationUrl)) {
        toast.error('Please enter a valid URL for product documentation');
        return false;
      }
    }

    // Validate description character limit
    if (formData.description && formData.description.length > 10000) {
      toast.error('Product description cannot exceed 10000 characters');
      return false;
    }

    return true;
  };

  const renderCostField = (costType) => {
    const periods = formData[costType.name] || [];
    const showDates = periods.some(period => period.cost > 0);

    return (
      <div key={costType.name}>
        <div className="flex items-center justify-between mb-2 font-bold">
          <div>{costType.label}</div>
          
          <button
            type="button"
            onClick={() => addCostPeriod(costType.name)}
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-[#bb1ccc] hover:text-[#000080] transition-colors"
            disabled={isSubmitting}
          >
            <Plus className="h-4 w-4" />
            <span>Add Row</span>
          </button>
        </div>
        {periods.map((period) => {
          // Get the current period from formData to ensure we have the latest start date
          const currentPeriod = formData[costType.name].find(p => p.id === period.id);
          return (
            <div key={period.id} className="flex items-center  space-x-4 mb-4">
              <div  className="flex flex-col" >
              <label className="block text-sm font-medium text-gray-700 mb-1">
            {/* {costType.label} */}
            Cost
          </label>
              <input
                type="number"
                required
                value={period.cost}
                onChange={(e) => updateCostPeriod(costType.name, period.id, 'cost', e.target.value === '' ? '' : Number(e.target.value))}
                className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Enter cost in $"
                disabled={isSubmitting}
                min="0"              />
                </div>
              {period.cost > 0 && (
                <>
                  <div className="flex flex-col">
                    <label className="text-sm text-gray-600 mb-1">Start Date</label>
                    <input
                      type="date"
                      required
                      value={period.startDate}
                      onChange={(e) => {
                        const newStartDate = e.target.value;
                        updateCostPeriod(costType.name, period.id, 'startDate', newStartDate);
                        // If end date is before new start date, clear it
                        if (period.endDate && new Date(period.endDate) <= new Date(newStartDate)) {
                          updateCostPeriod(costType.name, period.id, 'endDate', '');
                        }
                      }}
                      className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-sm text-gray-600 mb-1">End Date</label>
                    <input
                      type="date"
                      required
                      value={period.endDate}
                      min={currentPeriod?.startDate || undefined}
                      onChange={(e) => updateCostPeriod(costType.name, period.id, 'endDate', e.target.value)}
                      className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
                      disabled={isSubmitting}
                    />
                  </div>
                </>
              )}
              
              <button
                type="button"
                onClick={() => removeCostPeriod(costType.name, period.id)}
                className="text-[#bb1ccc] hover:text-[#000080] mt-[15px]"
                disabled={isSubmitting}
              >
                <Trash2 className="h-8 w-8" />
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  const renderThresholdField = (threshold) => {
    return (
      <div key={threshold.name} className="flex-1">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {threshold.label}
        </label>
        {renderField(threshold)}
      </div>
    );
  };

  const renderField = (field) => {
    const commonProps = {
      required: field.required,
      value: formData[field.name],
      onChange: field.name === 'productCode' ? handleProductCodeSelect : (e) => setFormData({...formData, [field.name]: e.target.value}),
      className: `w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500 ${
        (field.name === 'productCode' && isLoadingCodes) || 
        (isLoadingDetails && ['productName', 'description', 'dataLayer', 'domain', 'subDomain', 'productOwner'].includes(field.name)) ||
        (field.name === 'marketRegion' && isLoadingCodes)
          ? 'opacity-50 cursor-not-allowed'
          : ''
      }`,
      placeholder: field.placeholder,
      disabled: isSubmitting || 
        (field.name === 'productCode' && isLoadingCodes) || 
        (isLoadingDetails && ['productName', 'description', 'dataLayer', 'domain', 'subDomain', 'productOwner'].includes(field.name)) ||
        (field.name === 'marketRegion' && isLoadingCodes)
    };

    switch (field.type) {
      case 'select':
        if (field.name === 'marketRegion') {
          return (
            <Select
              isMulti
              name={field.name}
              options={regionsCountriesData.map(r => ({ value: r.region, label: r.region }))}
              value={selectedRegions}
              onChange={handleRegionChange}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder={commonProps.placeholder}
              isDisabled={commonProps.disabled}
              required={commonProps.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                  boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
                }),
              }}
            />
          );
        } else if (field.name === 'marketCountry') {
          return (
            <Select
              isMulti
              name={field.name}
              options={countryOptions}
              value={countryOptions.filter(option => formData.marketCountry.includes(option.value))}
              onChange={handleCountryChange}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder={commonProps.placeholder}
              isDisabled={commonProps.disabled || selectedRegions.length === 0}
              required={commonProps.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                  boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
                }),
              }}
            />
          );
        }
        return (
          <Select
            name={field.name}
            options={field.options}
            value={field.options.find(option => option.value === formData[field.name]) || null}
            onChange={(selectedOption) => {
              setFormData({
                ...formData,
                [field.name]: selectedOption ? selectedOption.value : ''
              });
            }}
            className="basic-single-select"
            classNamePrefix="select"
            placeholder={commonProps.placeholder}
            isDisabled={commonProps.disabled}
            required={commonProps.required}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
              }),
            }}
          />
        );
      case 'multiselect':
        return (
          <Select
            isMulti
            name={field.name}
            options={field.options}
            value={formData[field.name]}
            onChange={(selectedOptions) => {
              setFormData({
                ...formData,
                [field.name]: selectedOptions || []
              });
            }}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Select options..."
            isDisabled={isSubmitting}
            required={field.required}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
              }),
            }}
          />
        );
      case 'textarea':
        const isDescriptionField = field.name === 'description';
        const currentLength = formData[field.name]?.length || 0;
        const maxLength = 10000;
        const isOverLimit = currentLength > maxLength;
        const isNearLimit = currentLength > maxLength * 0.9; // 90% of limit (9000+ characters)
        
        return (
          <div>
            <textarea
              {...commonProps}
              rows={3}
              maxLength={maxLength}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= maxLength) {
                  setFormData({...formData, [field.name]: value});
                }
              }}
              className={`w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 ${
                isOverLimit 
                  ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
                  : isNearLimit 
                    ? 'border-orange-400 focus:ring-orange-400 focus:border-orange-400' 
                    : 'border-gray-300 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]'
              }`}
            />
            {isDescriptionField && (
              <div className="mt-1 flex justify-between items-center">
                <span className={`text-sm font-medium ${
                  isOverLimit 
                    ? 'text-red-600' 
                    : isNearLimit 
                      ? 'text-orange-600' 
                      : 'text-gray-500'
                }`}>
                  {currentLength}/{maxLength} characters
                </span>
                {isOverLimit && (
                  <span className="text-sm text-red-600 font-semibold bg-red-50 px-2 py-1 rounded">
                    ⚠️ You can't enter more than 10000 characters
                  </span>
                )}
                {isNearLimit && !isOverLimit && (
                  <span className="text-sm text-orange-600 font-medium">
                    ⚠️ Approaching character limit
                  </span>
                )}
              </div>
            )}
          </div>
        );
      case 'numberWithUnit':
        return (
          <div className="flex gap-4">
            <div className="flex-1">
              <input
                type="number"
                {...commonProps}
                value={formData[field.name] !== undefined && formData[field.name] !== null ? formData[field.name] : ''}
                onChange={(e) => {
                  const value = e.target.value === '' ? '' : parseInt(e.target.value, 10);
                  setFormData({...formData, [field.name]: value});
                }}
                placeholder="Enter size"
                min="0"
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
              />
            </div>
            <div className="w-32">
              <select
                {...commonProps}
                value={formData[`${field.name}Unit`] || ''}
                onChange={(e) => setFormData({...formData, [`${field.name}Unit`]: e.target.value})}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
              >
                <option value="">Unit</option>
                {field.unitOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        );
      case 'tagInput':
        return (
          <TagInput
            field={field}
            formData={formData}
            setFormData={setFormData}
            isSubmitting={isSubmitting}
          />
        );
      case 'slaResponseTime':
        return (
          <div className="flex gap-4">
            <div className="flex-1">
              <input
                type="number"
                required
                value={formData.slaResponseTime !== undefined && formData.slaResponseTime !== null ? formData.slaResponseTime : ''}
                onChange={(e) => setFormData({...formData, slaResponseTime: e.target.value === '' ? '' : Number(e.target.value)})}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
                placeholder="Enter response time"
                min="0"
                disabled={isSubmitting}
              />
            </div>
            <div className="w-32">
              <select
                value={formData.slaResponseTimeUnit}
                onChange={(e) => setFormData({...formData, slaResponseTimeUnit: e.target.value})}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
                disabled={isSubmitting}
                required
              >
                <option value="">Unit</option>
                <option value="hours">Hours</option>
                <option value="minutes">Minutes</option>
              </select>
            </div>
          </div>
        );
      case 'number':
        return (
          <input
            type="number"
            {...commonProps}
            min={field.name === 'slaUptime' ? 1 : 0}
            max={field.name === 'slaUptime' ? 100 : undefined}
            onChange={(e) => {
              const value = e.target.value === '' ? '' : Number(e.target.value);
              if (field.name === 'slaUptime' && value !== '') {
                if (value < 1) {
                  setFormData({...formData, [field.name]: 1});
                } else if (value > 100) {
                  setFormData({...formData, [field.name]: 100});
                } else {
                  setFormData({...formData, [field.name]: value});
                }
              } else if (value !== '') {
                // For other numeric fields, ensure minimum value is 0
                setFormData({...formData, [field.name]: Math.max(0, value)});
              } else {
                setFormData({...formData, [field.name]: value});
              }
            }}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
          />
        );
      default:
        return (
          <input
            type={field.type || 'text'}
            {...commonProps}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
          />
        );
    }
  };

  const renderProductNameField = () => {
    // If editing (id present), show disabled input with prefilled value
    if (id) {
      return (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Product Name
          </label>
          <input
            type="text"
            value={formData.productName || ''}
            disabled
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-gray-100 placeholder-gray-500"
            placeholder="Product name"
          />
        </div>
      );
    }
    // If creating (no id), show Select dropdown
    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Product Name
        </label>
        <Select
          options={productNameOptions}
          value={productNameOptions.find(option => option.value === selectedProductName) || null}
          onChange={handleProductNameSelect}
          placeholder="Select product name"
          isDisabled={isLoadingCodes}
          isLoading={isLoadingCodes}
          className="basic-single-select"
          classNamePrefix="select"
          styles={{
            control: (base, state) => ({
              ...base,
              borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
              boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
            }),
          }}
        />
      </div>
    );
  };

  const renderProductCodeField = () => {
    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Product Code
        </label>
        <input
          type="text"
          value={formData.productCode}
          onChange={e => setFormData({ ...formData, productCode: e.target.value })}
          placeholder="Enter product code"
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]  bg-gray-100 placeholder-gray-500"
          disabled
          required
        />
      </div>
    );
  };

  const renderProductOwnerField = () => {
    const hasEmail = formData.productOwner && formData.productOwner.trim() !== '';
    const isEmailInvalid = hasEmail && !isProductOwnerEmailValid;
    
    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Product Owner
        </label>
        <input
          type="email"
          value={formData.productOwner || ''}
          onChange={(e) => setFormData({...formData, productOwner: e.target.value})}
          className={`w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 bg-white placeholder-gray-500 ${
            isEmailInvalid 
              ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
              : 'border-gray-300 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]'
          }`}
          disabled={isSubmitting}
          placeholder={`Enter product owner email (${ALLOWED_EMAIL_DOMAINS.map(d => `@${d}`).join(', ')})`}
          required
        />
        {isEmailInvalid && (
          <p className="mt-1 text-sm text-red-600">
            Please enter a valid email address from: {ALLOWED_EMAIL_DOMAINS.join(', ')}
          </p>
        )}
      </div>
    );
  };

  const renderDomainField = () => {
    const domainField = formConfig.basicInformation.fields.find(f => f.name === 'domain');
    return (
      <div className="form-group">
        <label>{domainField.label}</label>
        <div className="flex items-center gap-2">
          {!isDomainEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={formData.domain || ''}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select domain"
              />
              <button
                type="button"
                onClick={() => setIsDomainEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              value={selectedDomain}
              onChange={handleDomainChange}
              options={domainData.map(d => ({
                value: d.parent_domain_id,
                label: d.parent_domain
              }))}
              placeholder={domainField.placeholder}
              className="basic-single-select w-full"
              classNamePrefix="select"
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                  boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderSubdomainField = () => {
    const subdomainField = formConfig.basicInformation.fields.find(f => f.name === 'subDomain');
    return (
      <div className="form-group">
        <label>{subdomainField.label}</label>
        <div className="flex items-center gap-2">
          {!isDomainEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={formData.subDomain}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select sub domain"
              />
              <button
                type="button"
                onClick={() => setIsDomainEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              value={selectedSubDomain}
              onChange={handleSubdomainChange}
              options={subdomainOptions}
              placeholder={subdomainField.placeholder}
              isDisabled={!selectedDomain}
              className="basic-single-select w-full"
              classNamePrefix="select"
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                  boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderSubSubdomainField = () => {
    const subSubdomainField = formConfig.basicInformation.fields.find(f => f.name === 'subSubDomain');
    return (
      <div className="form-group">
        <label>{subSubdomainField.label}</label>
        <div className="flex items-center gap-2">
          {!isDomainEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={formData.subSubDomain}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select sub sub domain"
              />
              <button
                type="button"
                onClick={() => setIsDomainEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              value={selectedSubSubDomain}
              onChange={handleSubSubdomainChange}
              options={subSubdomainOptions}
              placeholder={subSubdomainField.placeholder}
              isDisabled={!selectedSubDomain}
              className="basic-single-select w-full"
              classNamePrefix="select"
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                  boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderMarketRegionField = () => {
    const marketRegionField = formConfig.marketInformation.fields.find(f => f.name === 'marketRegion');
    return (
      <div className="form-group">
        <label>{marketRegionField.label}</label>
        <div className="flex items-center gap-2">
          {!isMarketEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={Array.isArray(formData.marketRegion) ? formData.marketRegion.join(', ') : formData.marketRegion || ''}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select regions"
              />
              <button
                type="button"
                onClick={() => setIsMarketEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              isMulti
              name="marketRegion"
              options={regionsCountriesData.map(r => ({ value: r.region, label: r.region }))}
              value={selectedRegions}
              onChange={handleRegionChange}
              className="basic-multi-select w-full"
              classNamePrefix="select"
              placeholder={marketRegionField.placeholder}
              isDisabled={isLoadingCodes}
              required={marketRegionField.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                  boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderMarketCountryField = () => {
    const marketCountryField = formConfig.marketInformation.fields.find(f => f.name === 'marketCountry');
    return (
      <div className="form-group">
        <label>{marketCountryField.label}</label>
        <div className="flex items-center gap-2">
          {!isMarketEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={Array.isArray(formData.marketCountry) ? formData.marketCountry.join(', ') : formData.marketCountry || ''}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select countries"
              />
              <button
                type="button"
                onClick={() => setIsMarketEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              isMulti
              name="marketCountry"
              options={countryOptions}
              value={countryOptions.filter(option => formData.marketCountry.includes(option.value))}
              onChange={handleCountryChange}
              className="basic-multi-select w-full"
              classNamePrefix="select"
              placeholder={marketCountryField.placeholder}
              isDisabled={selectedRegions.length === 0}
              required={marketCountryField.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                  boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderLineOfBusinessField = () => {
    const lineOfBusinessField = formConfig.marketInformation.fields.find(f => f.name === 'lineOfBusiness');
    return (
      <div className="form-group">
        <label>{lineOfBusinessField.label}</label>
        <div className="flex items-center gap-2">
          {!isMarketEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={
                  lineOfBusinessField.options.find(option => option.value === formData.lineOfBusiness)?.label || ''
                }
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select line of business"
              />
              <button
                type="button"
                onClick={() => setIsMarketEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              name="lineOfBusiness"
              options={lineOfBusinessField.options}
              value={lineOfBusinessField.options.find(option => option.value === formData.lineOfBusiness) || null}
              onChange={(selectedOption) => {
                setFormData({
                  ...formData,
                  lineOfBusiness: selectedOption ? selectedOption.value : ''
                });
              }}
              className="basic-single-select w-full"
              classNamePrefix="select"
              placeholder={lineOfBusinessField.placeholder}
              isDisabled={isSubmitting}
              required={lineOfBusinessField.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? '#bb1ccc' : base.borderColor,
                  boxShadow: state.isFocused ? '0 0 0 2px #bb1ccc' : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderSection = (section) => {
    return (
      <div className="space-y-6">
        <h3 className="text-lg font-bold text-[#bb1ccc]">{section.title}</h3>
        {section.fields && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pl-2">
            {section.fields.map(field => {
              if (field.name === 'productName') {
                return (
                  <div key={field.name}>
                    {renderProductNameField()}
                  </div>
                );
              }
              if (field.name === 'productCode') {
                return (
                  <div key={field.name}>
                    {renderProductCodeField()}
                  </div>
                );
              }

              if (field.name === 'productOwner') {
                return (
                  <div key={field.name}>
                    {renderProductOwnerField()}
                  </div>
                );
              }

              if (field.name === 'domain') {
                return (
                  <div key={field.name}>
                    {renderDomainField()}
                  </div>
                );
              }
              if (field.name === 'subDomain') {
                return (
                  <div key={field.name}>
                    {renderSubdomainField()}
                  </div>
                );
              }
              if (field.name === 'subSubDomain') {
                return (
                  <div key={field.name}>
                    {renderSubSubdomainField()}
                  </div>
                );
              }
              if (field.name === 'marketRegion') {
                return (
                  <div key={field.name}>
                    {renderMarketRegionField()}
                  </div>
                );
              }
              if (field.name === 'marketCountry') {
                return (
                  <div key={field.name}>
                    {renderMarketCountryField()}
                  </div>
                );
              }
              if (field.name === 'lineOfBusiness') {
                return (
                  <div key={field.name}>
                    {renderLineOfBusinessField()}
                  </div>
                );
              }
              return (
                <div key={field.name} className={field.name === 'description' ? 'md:col-span-2' : ''}>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {field.label}
                  </label>
                  {renderField(field)}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  const allFilesConfigured = uploadedFiles.every(file => fileConfigurations[file.id]);

  // Check if user is Data Engineer or Vendor
  const dataEngineerVendorRoles = ['Data Engineer', 'Vendor'];
  const isDataEngineerOrVendor = userRole ? dataEngineerVendorRoles.includes(userRole) : false;

  // Visual feedback for email validation
  const hasProductOwnerEmail = formData.productOwner && formData.productOwner.trim() !== '';
  const isEmailInvalidForButtons = hasProductOwnerEmail && !isProductOwnerEmailValid;

  return (
    <>
    <div className="max-w-[90%] mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold text-[#bb1ccc]">Onboard Data Product</h2>
            <p className="mt-1 text-sm text-gray-500">
              Provide basic information about your data product
            </p>
          </div>
          <div className="flex items-center justify-center">
            <div className="bg-blue-100 rounded-full p-3">
              <Box className="h-8 w-8 text-blue-600 m-auto" />
            </div>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6">
          {(isLoadingCodes || isLoadingDetails) && (
            <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
              <div className="flex flex-col items-center space-y-3">
                <img src={preloader} alt="Loading..." width={200} />
                <span className="text-gray-700 text-[20px]">
                Hang tight! The resources are loading...
                </span>
              </div>
            </div>
          )}
          
          <div className="space-y-8">
            {Object.entries(formConfig).map(([key, section]) => (
              <React.Fragment key={key}>
                {renderSection(section)}
                {key === 'costInformation' && (
                  <>
                    {formConfig.costInformation.costTypes.map(costType => renderCostField(costType))}
                    {formConfig.costInformation.thresholds && (
                      <div className="mt-6 flex gap-4">
                        {formConfig.costInformation.thresholds.map(threshold => renderThresholdField(threshold))}
                      </div>
                    )}
                    <div className="mt-6">
                      <div className="w-1/2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Azure Services Cost (Web App, Logic App)
                        </label>
                        <input
                          type="number"
                          name="azureServicesCost"
                          value={formData.azureServicesCost !== undefined && formData.azureServicesCost !== null ? formData.azureServicesCost : ''}
                          onChange={(e) => setFormData({...formData, azureServicesCost: e.target.value === '' ? '' : Number(e.target.value)})}
                          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
                          placeholder="Enter cost in $"
                          required
                          disabled={isSubmitting}
                          min="0" 
                        />
                      </div>
                    </div>
                  </>
                )}
              </React.Fragment>
            ))}
          </div>

          <div className="mt-8 flex justify-between">
            <Tooltip 
              title={isDataEngineerOrVendor ? "You are not authorized to save drafts" : ""}
              placement="top"
              arrow
            >
              <span>
                <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="px-4 py-2 border border-[#bb1ccc] text-white bg-[#bb1ccc] rounded-md hover:bg-[#000080] hover:border-[#000080] disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={isSubmitting || isSaving || isLoadingCodes || isLoadingDetails || isDataEngineerOrVendor}
                >
                  {isSaving ? (
                    <div className="flex items-center">
                     {/* <img src={heartLoading} alt="Loading..." className="h-12 " /> */}
                      <span>Saving...</span>
                    </div>
                  ) : (
                    'Save Draft'
                  )}
                </button>
              </span>
            </Tooltip>
            <Tooltip 
              title={isDataEngineerOrVendor ? "You are not authorized to submit this form" : ""}
              placement="top"
              arrow
            >
              <span>
                <button
                  type="submit"
                  className="flex items-center justify-center h-[45px] min-w-[150px] px-4 bg-[#bb1ccc] text-white rounded-md hover:bg-[#000080] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={isSubmitting || isSaving || isLoadingCodes || isLoadingDetails || !allFilesConfigured || isDataEngineerOrVendor}
                >
                  {isSubmitting ? (
                    <div className="flex items-center">
                      {/* <img src={heartLoading} alt="Loading..." className="h-12 " /> */}
                      <span>Submitting...</span>
                    </div>
                  ) : (
                    <>
                      <span className="mr-2">Next Step</span>
                      <ArrowRight className="h-4 w-4" />
                    </>
                  )}
                </button>
              </span>
            </Tooltip>
          </div>
        </form>
      </div>
      
      {/* <AssetSelectionModal
        id  = {proudctId}
        open={showAssetModal}
        onClose={() => setShowAssetModal(false)}
        selectedSources={
          Array.isArray(formData.assetSource)
            ? formData.assetSource
                .filter(s => s && (typeof s === 'string' || (typeof s === 'object' && s.value)))
                .map(s =>
                  typeof s === 'string'
                    ? s.toLowerCase()
                    : (s.value ? String(s.value).toLowerCase() : '')
                )
            : []
        }
        nextStep = {onNext}
      /> */}
    </div> <Toaster  position="top-right" />
    </>
  );
};

export default OnboardProduct;
